import { render } from "./FlatGauge.vue?vue&type=template&id=b1bcb1b0&scoped=true&ts=true"
import script from "./FlatGauge.vue?vue&type=script&lang=ts"
export * from "./FlatGauge.vue?vue&type=script&lang=ts"

import "./FlatGauge.vue?vue&type=style&index=0&id=b1bcb1b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1bcb1b0"]])

export default __exports__